import useLogout from './useLogout';

export default useLogout;
